<template>
  <span
    class="label font-weight-bold label-lg label-inline label-light-success"
    style="width: max-content"
    >{{ getMerchantName(merchantId) }}</span
  >
</template>

<script>
export default {
  props: ['merchantId'],
  data() {
    return {};
  },
  methods: {
    getMerchantName(merchantId) {
      switch (merchantId) {
        case 2:
          return 'TGMC';
        // merchantId 1 is the active brand's own merchant; its label depends on
        // the build (VF for vfxanh, NEG for neg). Same for any unknown/empty id.
        case 1:
        default:
          return this.$brand.merchantLabel;
      }
    },
  },
};
</script>
